<template>
    <NuxtLayout name="malt-full-layout">
        <main>
            <NuxtPage />
        </main>
        <template #admin-tools>
            <FooterAdminTools>
                <template #cta>
                    <LinkProjectWidget />
                </template>
            </FooterAdminTools>
        </template>
    </NuxtLayout>
</template>

<script setup lang="ts">
    import LinkProjectWidget from '@components/my-referrals/LinkProjectWidget.vue';
    import {storeToRefs} from 'pinia';
    import {NuxtPage, FooterAdminTools} from '#components';
    import {useAsyncData, useHead, useHostSettings, useScripts} from '#imports';
    import {usePreferencesStore, useReferralsStore} from '@/stores';

    const {data, error} = await useAsyncData('host-settings', () => useHostSettings(), {deep: true});
    if (!error.value) {
        const {loadScripts} = useScripts(data.value);
        useHead({script: await loadScripts()});
    }

    const preferencesStore = usePreferencesStore();
    const {preferences} = storeToRefs(preferencesStore);
    await useAsyncData(async () => await preferencesStore.fetchBusinessReferralWebPreferences(), {deep: true});

    const {openHowItWorksModal} = useReferralsStore();
    openHowItWorksModal(!preferences.value.onboardingAcknowledged);
</script>
